import type { CSSProperties } from 'react'

/** Shared SVG overlay for app-board icons and browser favicons. */
export const APP_ICON_DEPTH = {
  highlightOpacity: 0.1,
  shadowOpacity: 0.04,
  // Endpoints of the same 145-degree gradient on a square.
  x1: '10.058%',
  y1: '-7.043%',
  x2: '89.942%',
  y2: '107.043%',
} as const

/** Subtle app-only depth; the saved brand hex remains the dominant color. */
export function appIconStyle(background: string, foreground: string): CSSProperties {
  return {
    backgroundColor: background,
    backgroundImage: `linear-gradient(145deg, color-mix(in srgb, ${background}, white ${APP_ICON_DEPTH.highlightOpacity * 100}%) 0%, ${background} 50%, color-mix(in srgb, ${background}, black ${APP_ICON_DEPTH.shadowOpacity * 100}%) 100%)`,
    color: foreground,
  }
}
